import { render, staticRenderFns } from "./DashboardNav.vue?vue&type=template&id=6a90d904&scoped=true"
import script from "./DashboardNav.vue?vue&type=script&lang=js"
export * from "./DashboardNav.vue?vue&type=script&lang=js"
import style0 from "./DashboardNav.vue?vue&type=style&index=0&id=6a90d904&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a90d904",
  null
  
)

export default component.exports